export const content = {
  headline: 'Empfohlene Schneefangreihen',
  snowCatcherRows: ['Anzahl Schneefangreihen pro Dachseite', 'Reihe(n)'],
  supportDistance: ['Stützenabstand', 'm'],
  supports: ['Gesamtanzahl Stützen', 'Stück'],
}
